module.exports = __webpack_public_path__ + "img/home_b-2.b37b7061.png";